var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Classes
import App from './App.js';
import eventBus from '../eventBus.js';

/**
 * A modular app container that extends {@link App} and adds an eventBus
 * in addition to implement the {@link Component} interface.
 * @implements {Component}
 */

var AppExt = function (_App) {
	_inherits(AppExt, _App);

	/**
  * Creates an extended App instance.<br>
  * The optional module configuration may be overridden using the url query.<br>
  * Eg. "?login.auto=true" would pass {auto: "true"} as parameter to the login app module.
  * If a module configuration has the property "active" set to the strings "false", "no",
  * or "0", or has value false or 0, it will automatically be deactivated on load.
  * @param {Object.<string,object>} [moduleConfig] App module configuration key-value object where the key is the name of the module and the value is the parameters passed to the module on creation.
  * @param {object} [opt] App configuration
  * @param {App~moduleClassCallback} [opt.moduleClass] Callback for fetching the {@link AppModule} class for a given module name.
  * @param {string} [opt.queryNamespace] Namespace prefix for query params. Eg. 'mod' for ?mod.login.auto=true . Defaults to no namespace.
   * @param {EventBus} [opt.eventBus] Event bus.
  * @param {string} [opt.eventBusNamespace] Namespace prefix for the event bus. Defaults to 'app'.
  */
	function AppExt(moduleConfig) {
		var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, AppExt);

		// Module configuration
		var _this = _possibleConstructorReturn(this, (AppExt.__proto__ || Object.getPrototypeOf(AppExt)).call(this, moduleConfig, opt));

		_this._eventBus = opt.eventBus || eventBus;
		_this._eventBusNamespace = opt.eventBusNamespace || 'app';
		return _this;
	}

	/**
  * The event bus used by the AppExt
  */


	_createClass(AppExt, [{
		key: 'on',


		/**
   * Attach an event handler function for one or more app events.<br>
   * @param {?string} events One or more space-separated events. Null means any event.
   * @param {EventBus~eventCallback} handler A function to execute when the event is emitted.
   */
		value: function on(events, handler) {
			this._eventBus.on(this, events, handler, this._eventBusNamespace);
		}

		/**
   * Remove an app event handler.
   * @param {?string} events One or more space-separated events. Null means any event.
   * @param {function} [handler] An optional handler function. The handler will only be remove if it is the same handler.
   */

	}, {
		key: 'off',
		value: function off(events, handler) {
			this._eventBus.off(this, events, handler, this._eventBusNamespace);
		}

		/**
   * Sets the screen component and renders it if the screen is rendered.<br>
   * Usually called by the app module responsible for displaying the initial
   * loading screen, the login screen, or the overall layout.
   * @param {Component} component Component to set.
   */

	}, {
		key: 'setComponent',
		value: function setComponent(component) {
			component = component || null; // Ensure falsy values are cast to null

			// Has the component changed?
			if (component === this._component) return;

			if (!this._el) {
				this._component = component;
				return;
			}

			// Unrender if we have a component and it is rendered
			if (this._component) {
				this._component.unrender();
			}

			this._component = component;
			this._renderScreen();
		}

		/**
   * Unsets a component if it matches the one set
   * @param {Component} component Component to unset
   */

	}, {
		key: 'unsetComponent',
		value: function unsetComponent(component) {
			if (component === this._component) {
				this.setComponent(null);
			}
		}

		/**
   * Check if a component has been set.
   * @returns {boolean} True if a component has been set, otherwise false
   */

	}, {
		key: 'hasComponent',
		value: function hasComponent() {
			return this._component ? true : false;
		}

		/**
   * Renders the component set with setComponent()
   * @param {HTMLElement|DocumentFragment} el Parent element in which to render the contents.
  	 * @returns {this}
  	 */

	}, {
		key: 'render',
		value: function render(el) {
			this._el = el;
			this._renderScreen();
			return this;
		}

		/**
   * Unrenders the app
   */

	}, {
		key: 'unrender',
		value: function unrender() {
			if (!this._el) return;
			if (this._component) {
				this._component.unrender();
			}

			this._el = null;
		}

		/**
   * Renders the set component
   * @private
   */

	}, {
		key: '_renderScreen',
		value: function _renderScreen() {
			if (this._el && this._component) {
				this._component.render(this._el);
			}
		}
	}, {
		key: 'eventBus',
		get: function get() {
			return this._eventBus;
		}
	}]);

	return AppExt;
}(App);

export default AppExt;